await import(`@liferay/language/${Liferay.ThemeDisplay.getLanguageId()}/data-engine-taglib/all.js`);
/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import React from 'react';

import FieldType from './FieldType.es';

export default function FieldTypeDragPreview(props) {
	return (
		<div className="field-type-drag-preview">
			<FieldType {...props} />
		</div>
	);
}
